// @flow

export const camelCaseToUnderscore = (string: string) => {
  return string
    .replace(/(?:^|\.?)([A-Z])/g, function(x, y) {
      return "_" + y.toLowerCase();
    })
    .replace(/^_/, "");
};

export const transformToValidId = (string: string): string =>
  string.toLowerCase().replace(/\s/g, "-");

export const currencyTransform = (
  string: *,
  options?: $Exact<{ currencyType: string, withFraction: boolean }>,
) => {
  const currencyType = (options && options.currencyType) || "GBP";
  const withFraction = (options && options.withFraction) || false;
  const formatter = new Intl.NumberFormat("en-UK", {
    style: "currency",
    currency: currencyType,
  });

  return withFraction ? formatter.format(string) : formatter.format(string).replace(/\D00$/, "");
};
